import { RefreshCw } from 'lucide-react';

interface UpdateToastViewProps {
  show: boolean;
  onUpdate: () => void;
}

/**
 * Presentational half of SWUpdateToast — kept free of the
 * `virtual:pwa-register` import so it stays unit-testable.
 */
export function UpdateToastView({ show, onUpdate }: UpdateToastViewProps) {
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-md">
      <button
        onClick={onUpdate}
        className="w-full flex items-center justify-center gap-3 p-4 rounded-full bg-coral text-white shadow-pixel font-grotesk font-bold text-[13px] hover:bg-coral-hover transition-colors"
        aria-label="Update to the new version"
      >
        <RefreshCw size={16} className="shrink-0 animate-spin [animation-duration:3s]" />
        NEW VERSION READY — TAP TO UPDATE
      </button>
    </div>
  );
}
